import { useLatestCallback } from 'hook/useLatestCallback'
import { useState } from 'react'

interface ConfirmOptions {
  title?: string
  message?: string
  confirmText?: string
  cancelText?: string
  confirmVariant?: 'primary' | 'danger' | 'warning'
}

interface ConfirmState extends ConfirmOptions {
  open: boolean
  onConfirm?: () => void
}

export const useConfirm = () => {
  const [state, setState] = useState<ConfirmState>({
    open: false,
  })

  const confirm = useLatestCallback((
    onConfirm: () => void,
    options: ConfirmOptions = {}
  ) => {
    setState({
      open: true,
      onConfirm,
      ...options,
    })
  })

  const close = useLatestCallback(() => {
    setState(prev => ({ ...prev, open: false }))
  })

  const handleConfirm = useLatestCallback(() => {
    if (state.onConfirm) {
      state.onConfirm()
    }
    close()
  })

  return {
    confirm,
    close,
    state,
    handleConfirm,
  }
} 